import React, { Component } from 'react';
import { Button, Input, InputGroup } from 'reactstrap';
import { RepPortalTableSmall } from './RepPortalTableSmall';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';
import moment from 'moment';
import { FetchData } from './utils/DataFetch';
import { LoadingModal } from './LoadingModal';
import { GetCookie } from './utils/Common';
import RefreshIcon from '../images/merge-icon.png';

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  cellStyle: { borderRight: '1px solid #ccc' },
};

const columnDefs = [
  {
    headerName: 'Rep',
    field: 'repLastName',
    width: 160,
    cellRenderer: 'repCellRenderer',
  },
  { headerName: 'Job #', field: 'jobNum', width: 90 },
  {
    headerName: 'Date',
    field: 'jobDateTime',
    colId: 'jobDate',
    width: 110,
    cellRenderer: 'dateCellRenderer',
  },
  {
    headerName: 'Time',
    field: 'jobDateTime',
    colId: 'jobTime',
    width: 100,
    cellRenderer: 'timeCellRenderer',
  },
  {
    headerName: 'Claimant',
    field: 'clmLastName',
    width: 160,
    cellRenderer: 'claimantCellRenderer',
  },
  { headerName: 'Claim #', field: 'clmClaimNumber', width: 130 },
  {
    headerName: 'Interpreter',
    field: 'intLastName',
    width: 160,
    cellRenderer: 'interpreterCellRenderer',
  },
  { headerName: 'Language', field: 'clmLanguage', width: 120 },
  { headerName: 'Location', field: 'aptCity', width: 130 },
  {
    headerName: 'Invoiced',
    field: 'invoicedFlg',
    width: 100,
    cellRenderer: 'boolCellRenderer',
  },
  {
    headerName: 'Authorized',
    field: 'repAuthorizedFlg',
    colId: 'repAuthorized',
    width: 110,
    cellRenderer: 'boolCellRenderer',
  },
  {
    headerName: 'Failed',
    field: 'failedFlg',
    width: 90,
    cellRenderer: 'boolCellRenderer',
  },
  {
    headerName: '',
    field: 'repAuthorizedFlg',
    colId: 'authorizeBtn',
    width: 110,
    sortable: false,
    filter: false,
    cellRenderer: 'authorizeCellRenderer',
  },
];

class DateCellRenderer extends Component {
  render() {
    return this.props.value ? moment(this.props.value).format('MM/DD/YYYY') : '';
  }
}

class TimeCellRenderer extends Component {
  render() {
    return this.props.value ? moment(this.props.value).format('h:mm A') : '';
  }
}

class RepCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data) return '';
    if (!data.repLastName && !data.repFirstName) return '';
    return `${data.repLastName || ''}, ${data.repFirstName || ''}`.trim().replace(/^,\s*/, '');
  }
}

class ClaimantCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data) return '';
    return `${data.clmLastName || ''}, ${data.clmFirstName || ''}`.trim().replace(/^,\s*/, '');
  }
}

class InterpreterCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data) return '';
    if (!data.intLastName && !data.intFirstName) return '';
    return `${data.intLastName || ''}, ${data.intFirstName || ''}`.trim().replace(/^,\s*/, '');
  }
}

class BoolCellRenderer extends Component {
  render() {
    return this.props.value ? 'Yes' : '';
  }
}

class AuthorizeCellRenderer extends Component {
  render() {
    const { data, context } = this.props;
    if (!data || data.repAuthorizedFlg) return '';
    return (
      <Button
        color="success"
        size="sm"
        style={{ padding: '2px 8px', fontSize: '0.75rem' }}
        onClick={() => context.onAuthorize(data.jobId)}
      >
        Authorize
      </Button>
    );
  }
}

export class RepPortal extends Component {
  static displayName = RepPortal.name;

  constructor(props) {
    super(props);
    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      workOrderList: [],
      loading: false,
      startDate: '',
      endDate: '',
      repSearch: '',
      claimNumber: '',
      multiFilter: false,
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleAuthorize = this.handleAuthorize.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const { startDate, endDate, repSearch, claimNumber } = this.state;
    this.setState({ loading: true });

    const model = {
      StartDate: startDate || null,
      EndDate: endDate || null,
      Rep: repSearch || null,
      ClmClaimNumberNoDash: claimNumber || '',
    };

    FetchData('/getrepjobs', 'POST', this.user.token, model).then((data) => {
      this.setState({ workOrderList: Array.isArray(data) ? data : [], loading: false });
    });
  }

  handleRefresh() {
    this.setState({ startDate: '', endDate: '', repSearch: '', claimNumber: '' }, this.fetchData);
  }

  handleAuthorize(jobId) {
    FetchData('/repauthorize', 'POST', this.user.token, { JobId: jobId }).then(() => {
      this.fetchData();
    });
  }

  handleFocus(fieldName) {
    if (!this.state.multiFilter) {
      this.setState({
        startDate: fieldName === 'startDate' ? this.state.startDate : '',
        endDate: fieldName === 'endDate' ? this.state.endDate : '',
        repSearch: fieldName === 'repSearch' ? this.state.repSearch : '',
        claimNumber: fieldName === 'claimNumber' ? this.state.claimNumber : '',
      });
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  render() {
    const { loading, startDate, endDate, repSearch, claimNumber, multiFilter, workOrderList } = this.state;

    return (
      <div style={{ paddingTop: '12px', paddingBottom: '24px' }}>
        <LoadingModal fetchingData={loading} />

        <InputGroup size="sm" style={{ width: 'fit-content', marginBottom: '8px', marginTop: '12px', paddingLeft: '4px' }}>
          <input
            type="checkbox"
            checked={multiFilter}
            onChange={() => this.setState({ multiFilter: !multiFilter })}
            style={{ marginRight: '6px', alignSelf: 'center' }}
          />
          <Input
            type="date"
            value={startDate}
            onChange={(e) => this.setState({ startDate: e.target.value })}
            onFocus={() => this.handleFocus('startDate')}
            onKeyDown={(e) => e.key === 'Enter' && this.fetchData()}
            style={{ width: '145px' }}
          />
          <Input
            type="date"
            value={endDate}
            onChange={(e) => this.setState({ endDate: e.target.value })}
            onFocus={() => this.handleFocus('endDate')}
            onKeyDown={(e) => e.key === 'Enter' && this.fetchData()}
            style={{ width: '145px' }}
          />
          <Input
            type="text"
            placeholder="Search colleague by name"
            value={repSearch}
            onChange={(e) => this.setState({ repSearch: e.target.value })}
            onFocus={() => this.handleFocus('repSearch')}
            onKeyDown={(e) => e.key === 'Enter' && this.fetchData()}
            style={{ width: '200px' }}
          />
          <Input
            type="text"
            placeholder="Claim #"
            value={claimNumber}
            onChange={(e) => this.setState({ claimNumber: e.target.value })}
            onFocus={() => this.handleFocus('claimNumber')}
            onKeyDown={(e) => e.key === 'Enter' && this.fetchData()}
            style={{ width: '130px' }}
          />
          <Button color="btn" onClick={this.handleRefresh}>
            <img src={RefreshIcon} style={{ width: '16px', height: '16px' }} alt="Refresh" />
          </Button>
        </InputGroup>

        <div className="d-none d-md-block">
          <div className="ag-theme-balham" style={{ width: '100%', height: '620px' }}>
            <AgGridReact
              columnDefs={columnDefs}
              rowData={workOrderList}
              defaultColDef={defaultColDef}
              onGridReady={this.onGridReady}
              animateRows={true}
              rowHeight={33}
              getRowId={(params) => params.data.jobId}
              context={{ onAuthorize: this.handleAuthorize }}
              components={{
                dateCellRenderer: DateCellRenderer,
                timeCellRenderer: TimeCellRenderer,
                repCellRenderer: RepCellRenderer,
                claimantCellRenderer: ClaimantCellRenderer,
                interpreterCellRenderer: InterpreterCellRenderer,
                boolCellRenderer: BoolCellRenderer,
                authorizeCellRenderer: AuthorizeCellRenderer,
              }}
            />
          </div>
        </div>
        <div className="d-md-none">
          <RepPortalTableSmall workOrders={workOrderList} onAuthorize={this.handleAuthorize} />
        </div>
      </div>
    );
  }
}
